<template>
	<div class="common_page">
		<Page :total="total" :page-size="pageSize" :current="current" @on-change="onChange" />
	</div>
</template>

<script>
	export default {
	  props: {
	    total: {
	      type: Number,
	      default: 0
	    },
	    pageSize: {
	      type: Number,
	      default: 10
	    },
	    current: {
	      type: Number,
	      default: 1
	    }
	  },
	  methods: {
	    onChange (page) {
	      this.$emit("on-change", page);
	    }
	  }
	};
</script>

<style type="text/css">
	#kmos .common_page .ivu-page-item-active {
		border-color: #CFAA72;
		background: #CFAA72;
	}
	#kmos .common_page .ivu-page-item-active a, .ivu-page-item-active:hover a {
		color: #ffffff;
	}
	#kmos .common_page .ivu-page-item:hover {
		border-color: #CFAA72;
		background: #CFAA72;
		border-color: #CFAA72;
	}
	#kmos .common_page .ivu-page-item:hover a {
		color: #ffffff;
	}
	#kmos .common_page .ivu-page-next:hover, .ivu-page-prev:hover {
		border-color: #CFAA72;
		background: #CFAA72;
	}
	#kmos .common_page .ivu-page-next:hover a, .ivu-page-prev:hover a {
		color: #ffffff;
	}
	#kmos .common_page a {
		color: #CFAA72;
	}
</style>
<style scoped>
	.common_page {
		text-align: center;
		padding: .40rem 0;
		margin-bottom: 20px;
	}
</style>


// WEBPACK FOOTER //
// src/oldCode/components/common/page.vue